export default __webpack_public_path__ + "images/0xce1bffbd5374dac86a2893119683f4911a2f7814.png";